var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReconnectArrow = function SvgReconnectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10.528 12.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.497 0c.275 0 .498.223.498.497v7.378H8.83L5.948 4.994a.497.497 0 1 1 .704-.704l3.73 3.73a.497.497 0 0 1 0 .704l-3.73 3.73a.497.497 0 1 1-.704-.703L8.83 8.87H.497A.497.497 0 0 1 0 8.372V.497C0 .223.223 0 .497 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgReconnectArrow;